"use strict";
/**
 *  @module SDK
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSDK = void 0;
var tslib_1 = require("tslib");
var index_js_1 = require("./resources/index.js");
var index_js_2 = tslib_1.__importDefault(require("./sdk/index.js"));
tslib_1.__exportStar(require("./api/index.js"), exports);
tslib_1.__exportStar(require("./common/index.js"), exports);
tslib_1.__exportStar(require("./errors/index.js"), exports);
tslib_1.__exportStar(require("./resources/index.js"), exports);
tslib_1.__exportStar(require("./utils/index.js"), exports);
exports.BaseSDK = index_js_2.default;
var SDK = /** @class */ (function (_super) {
    tslib_1.__extends(SDK, _super);
    function SDK(options) {
        var _this = _super.call(this, options) || this;
        _this.bankAccounts = new index_js_1.BankAccounts(_this.api);
        _this.cancels = new index_js_1.Cancels(_this.api);
        _this.captures = new index_js_1.Captures(_this.api);
        _this.charges = new index_js_1.Charges(_this.api);
        _this.checkoutInfo = new index_js_1.CheckoutInfo(_this.api);
        _this.ecInfo = new index_js_1.ECInfo(_this.api);
        _this.ecFormLinks = new index_js_1.ECFormLinks(_this.api);
        _this.ecForms = new index_js_1.ECForms(_this.api);
        _this.emails = new index_js_1.Emails(_this.api);
        _this.exchangeRates = new index_js_1.ExchangeRates(_this.api);
        _this.ledgers = new index_js_1.Ledgers(_this.api);
        _this.merchants = new index_js_1.Merchants(_this.api);
        _this.platforms = new index_js_1.Platforms(_this.api);
        _this.products = new index_js_1.Products(_this.api);
        _this.refunds = new index_js_1.Refunds(_this.api);
        _this.stores = new index_js_1.Stores(_this.api);
        _this.subscriptions = new index_js_1.Subscriptions(_this.api);
        _this.transactionTokens = new index_js_1.TransactionTokens(_this.api);
        _this.transfers = new index_js_1.Transfers(_this.api);
        _this.verification = new index_js_1.Verification(_this.api);
        _this.webHooks = new index_js_1.WebHooks(_this.api);
        return _this;
    }
    return SDK;
}(index_js_2.default));
exports.default = SDK;
//# sourceMappingURL=index.js.map